var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nobox"},[_c('div',{staticClass:"block-title"},[_vm._v("费用统计")]),_c('div',{attrs:{"id":""}},[_c('div',{ref:"chartDiv2",staticStyle:{"float":"left","width":"100%","height":"250px"},attrs:{"id":"fb04"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }